var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakeLogoUnstake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.688 22.5054L29.6879 22.5054L22.7501 18.5001L29.6879 14.495C29.6879 14.495 29.6879 14.495 29.6879 14.495C31.1191 13.669 32.8823 13.669 34.3134 14.495C35.7446 15.3211 36.6259 16.848 36.6259 18.5001C36.6259 20.1526 35.7446 21.6793 34.3134 22.5054L34.3134 22.5054C32.8822 23.3316 31.1191 23.3316 29.688 22.5054Z",
    stroke: "#F2F2F4",
    strokeOpacity: 0.25,
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68769 14.495L2.68771 14.495C4.11868 13.669 5.88201 13.669 7.31299 14.495L7.31299 14.495L14.2511 18.5001L7.31299 22.5054L7.31296 22.5054C5.882 23.3316 4.1187 23.3316 2.68774 22.5054L2.68769 22.5054C1.25654 21.6793 0.375 20.1526 0.375 18.5001C0.375 16.848 1.25654 15.3211 2.68769 14.495Z",
    stroke: "#F2F2F4",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5049 7.31302L22.5049 7.31303L18.4996 14.2509L14.4946 7.31305C14.4946 7.31305 14.4946 7.31304 14.4945 7.31303C13.6685 5.88185 13.6685 4.11872 14.4946 2.68754C15.3206 1.25642 16.8475 0.375057 18.4996 0.375057C20.1521 0.375057 21.6788 1.25642 22.5049 2.68754L22.5049 2.68757C23.3312 4.11874 23.3312 5.88185 22.5049 7.31302Z",
    stroke: "#F2F2F4",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4946 34.3133L14.4946 34.3133C13.6685 32.8823 13.6685 31.119 14.4945 29.688L14.4946 29.688L18.4996 22.7499L22.5049 29.688L22.5049 29.688C23.3312 31.119 23.3312 32.8823 22.5049 34.3132L22.5049 34.3133C21.6788 35.7444 20.1521 36.626 18.4996 36.626C16.8475 36.626 15.3206 35.7444 14.4946 34.3133Z",
    stroke: "#F2F2F4",
    strokeOpacity: 0.25,
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeLogoUnstake);
export default __webpack_public_path__ + "static/media/stake-logo-unstake.06f5fba6.svg";
export { ForwardRef as ReactComponent };